/* ============================================
   TOMAHAWK APPAREL — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ------------------------------------------
     HERO SLIDESHOW
  ------------------------------------------ */
  var track  = document.getElementById('hero-track');
  var dots   = document.querySelectorAll('.hdot');
  var slide  = 0;
  var total  = dots.length;
  var timer;

  function goSlide(n) {
    slide = n;
    if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
    dots.forEach(function (d, i) {
      d.classList.toggle('on', i === n);
      d.setAttribute('aria-selected', i === n ? 'true' : 'false');
    });
  }

  function nextSlide() { goSlide((slide + 1) % total); }

  var autoplayMs = (window.__heroAutoplaySpeed && window.__heroAutoplaySpeed > 0)
    ? window.__heroAutoplaySpeed
    : 4600;
  function startAuto() { timer = setInterval(nextSlide, autoplayMs); }
  function stopAuto()  { clearInterval(timer); }

  if (track) {
    startAuto();
    track.addEventListener('mouseenter', stopAuto);
    track.addEventListener('mouseleave', startAuto);
    track.addEventListener('touchstart', stopAuto, { passive: true });
  }

  /* expose goSlide for inline onclick handlers in the section */
  window.goSlide = goSlide;


  /* ------------------------------------------
     SIZE SELECTOR → VARIANT INPUT SYNC
     Maps each size <select> to its hidden
     variant <input> inside the same form.
  ------------------------------------------ */
  var sizeSelects = document.querySelectorAll('.size-select');

  sizeSelects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('.prod-card').querySelector('.atc-form');
      if (!form) return;
      var variantInput = form.querySelector('.variant-input');
      if (variantInput) variantInput.value = sel.value;
    });
  });


  /* ------------------------------------------
     AJAX ADD TO CART
     Intercepts form submission, posts to
     /cart/add.js, updates badge + shows toast.
  ------------------------------------------ */
  var forms = document.querySelectorAll('.atc-form');
  var toast = createToast();

  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn      = form.querySelector('.prod-btn');
      var variantId = form.querySelector('.variant-input').value;
      var card     = form.closest('.prod-card');
      var colorEl  = card ? card.querySelector('.prod-color') : null;
      var color    = colorEl ? colorEl.textContent.trim() : '';

      if (!variantId) {
        showToast('Please select a size.', true);
        return;
      }

      btn.classList.add('loading');
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function () {
        updateCartCount();
        var sizeEl = card ? card.querySelector('.size-select') : null;
        var size   = sizeEl ? sizeEl.options[sizeEl.selectedIndex].text : '';
        showToast('The Frontier Shirt – ' + color + (size ? ' / ' + size : '') + ' added to cart.');
        btn.classList.remove('loading');
        btn.textContent = 'Add to Cart';
      })
      .catch(function () {
        showToast('Something went wrong. Please try again.', true);
        btn.classList.remove('loading');
        btn.textContent = 'Add to Cart';
      });
    });
  });


  /* ------------------------------------------
     CART COUNT — fetch /cart.js for live count
  ------------------------------------------ */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.getElementById('cart-count');
        if (badge) badge.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  /* run once on page load to ensure badge is current */
  updateCartCount();


  /* ------------------------------------------
     TOAST NOTIFICATION
  ------------------------------------------ */
  function createToast() {
    var el = document.createElement('div');
    el.id = 'tw-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    return el;
  }

  var toastTimeout;
  function showToast(msg, isError) {
    clearTimeout(toastTimeout);
    toast.textContent = msg;
    toast.style.borderLeftColor = isError ? '#c0392b' : '#B8935A';
    toast.classList.add('show');
    toastTimeout = setTimeout(function () {
      toast.classList.remove('show');
    }, 3000);
  }

});
